export default __webpack_public_path__ + "static/media/lightTheme.4d5c0fd3.svg";